import { render, staticRenderFns } from "./mncmcc.vue?vue&type=template&id=88be2346&"
import script from "./mncmcc.vue?vue&type=script&lang=js&"
export * from "./mncmcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports